import ExpandableContent from '@app/components/ExpandableContent'
import SimpleFilesView from '@app/components/SimpleFilesView'
import { ICityProfile } from '@app/models/CityProfile'
import * as React from 'react'
import { Label } from 'reactstrap'

interface ICityProfileDetailsProps {
  cityProfile: ICityProfile
  className?: string
  style?: React.CSSProperties
}

export default class CityProfileDetails extends React.PureComponent<
  ICityProfileDetailsProps
> {
  public render() {
    return (
      <div>
        {this.props.cityProfile.overview && (
          <div className='mb-2'>
            <Label>Overview</Label>
            <ExpandableContent className='mx-3'>
              <div className='white-space-pre'>
                {this.props.cityProfile.overview}
              </div>
            </ExpandableContent>
          </div>
        )}
        <div className='mb-2'>
          <Label>Retail Node Maps</Label>
          <SimpleFilesView
            className='mx-3'
            files={this.props.cityProfile.retailNodeMaps}
          />
        </div>
        <div className='mb-2'>
          <Label>Regional Maps</Label>
          <SimpleFilesView
            className='mx-3'
            files={this.props.cityProfile.regionalMaps}
          />
        </div>
        <div className='mb-2'>
          <Label>Competitors in the Market Maps</Label>
          <SimpleFilesView
            className='mx-3'
            files={this.props.cityProfile.competitorsMaps}
          />
        </div>
        <div className='mb-2'>
          <Label>Traffic Count Maps</Label>
          <SimpleFilesView
            className='mx-3'
            files={this.props.cityProfile.trafficCountMaps}
          />
        </div>
        <div className='mb-2'>
          <Label>Top Brokers</Label>
          <SimpleFilesView
            className='mx-3'
            files={this.props.cityProfile.topBrokers}
          />
        </div>
        <div className='mb-2'>
          <Label>Chamber of Commerce Files</Label>
          <SimpleFilesView
            className='mx-3'
            files={this.props.cityProfile.chamberOfCommerceFiles}
          />
        </div>
      </div>
    )
  }
}
